import { render, staticRenderFns } from "./SetSwitch.vue?vue&type=template&id=2f7b6968"
import script from "./SetSwitch.vue?vue&type=script&lang=js"
export * from "./SetSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports